// extracted by mini-css-extract-plugin
module.exports = {"loader":"IconArrowHead_loader___v8aL","root":"IconArrowHead_root__3HL-t"};